import { formatBaht } from '@pos/types';

// TODO(M0-BOOT-01): move to packages/shared
export const fmtAmount = (satang: number): string => {
  const sign = satang < 0 ? '-' : '';
  const baht = formatBaht(Math.abs(satang));
  const [whole, frac] = baht.split('.');
  return `${sign}${parseInt(whole).toLocaleString('en-US')}.${frac}`;
};
export const fmtBaht = (satang: number): string => `${fmtAmount(satang)} บาท`;
export const fmtInt = (n: number): string => n.toLocaleString('en-US');
export const fmtQty = (n: number, unit: string): string =>
  `${fmtInt(n)} ${unit}`;
export const fmtDate = (d: Date | number = new Date()): string => {
  const date = typeof d === 'number' ? new Date(d) : d;
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  return `${dd}/${mm}/${date.getFullYear()}`;
};
export const fmtPct = (n: number): string =>
  `${n.toLocaleString('en-US', { maximumFractionDigits: 1 })}%`;

/** Compact axis labels: 360000 → "360k", 1_250_000 → "1.3M", small/negative pass through. */
export const fmtCompact = (n: number): string => {
  const abs = Math.abs(n);
  if (abs >= 1_000_000)
    return `${(n / 1_000_000).toLocaleString('en-US', { maximumFractionDigits: 1 })}M`;
  if (abs >= 1_000)
    return `${(n / 1_000).toLocaleString('en-US', { maximumFractionDigits: abs < 10_000 ? 1 : 0 })}k`;
  return fmtInt(n);
};
/** Baht for chart tooltips/labels, e.g. "฿343,518". Accepts satang. */
export const fmtBahtShort = (satang: number): string =>
  `฿${fmtInt(Math.round(satang / 100))}`;
/** Compact axis labels for satang-valued chart ticks, e.g. 4_900_000 satang → "49k". */
export const fmtSatangCompact = (satang: number): string =>
  fmtCompact(Math.round(satang / 100));

import type { Product } from '../types/domain';
/** Format a base-unit quantity into descending human units, e.g. 150 → "1 ลัง 6 ขวด". */
export const fmtStockBreakdown = (
  baseQty: number,
  product: Product,
): string => {
  const units = [...product.units].sort((a, b) => b.factor - a.factor); // largest first
  let rest = Math.max(0, Math.trunc(baseQty));
  const parts: string[] = [];
  for (const u of units) {
    if (u.factor <= 0) continue;
    const n = Math.floor(rest / u.factor);
    if (n > 0) {
      parts.push(`${fmtInt(n)} ${u.unit}`);
      rest -= n * u.factor;
    }
  }
  if (parts.length === 0) {
    const base = units[units.length - 1];
    return `0 ${base?.unit ?? product.baseUnit}`;
  }
  return parts.join(' ');
};
